<template>
  <card>
    <list
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :itemLink="itemLink"
      :setLink="setLink"
      :fields="fields"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      val: [],
      modalCreate: "product",
      fields: [
        {
          col: " col-12 col-md-12",
          key: "name",
          label: "Название",
          type: "field",
          textType: "text",
        },

        {
          col: " col-12 col-md-12",
          key: "dealer",
          label: "Владелец ",
          type: "select",
          modal: "dealer",
          selectKey: "full_name",
        },

        {
          col: " col-12 col-md-12",
          key: "new_images",
          resultKey: "media",
          label: "Фотографии торговой точки",
          type: "imgs",
          image_key: "path_small",
          link: "media",
        },
        {
          col: " col-12 col-md-12",
          key: "location_id",
          label: "Адрес",
          type: "location",
        },
        {
          col: " col-12 col-md-12",
          key: "address",
          label: "Адрес",
          type: "field",
          textType: "text",
          isMultiLang: true,
        },
        {
          col: " col-12 col-md-12",
          key: "description",
          label: "Ориентир",
          type: "textarea",
          isMultiLang: true,
        },
        {
          col: " col-12 col-md-6",
          key: "lat",
          label: "Широта",
          type: "field",
          textType: "number",
        },
        {
          col: " col-12 col-md-6",
          key: "lon",
          label: "Долгота",
          type: "field",
          textType: "number",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_shop",
      itemLink: "my-shops",
      setLink: "my-shops",
      columns: [
        {
          key: "id",
          title: "ID",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
          sortBy: "id",
        },
        {
          key: "name",
          title: "Название",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "address",
          title: "Адрес",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },

        {
          key: "dealer",
          object: "phone",
          control: false,
          disableLink: true,
          align: "left",
          title: "Номер владельца",
        },
        {
          key: "dealer",
          object: "llc_name",
          title: "Организация",
          control: false,
          disableLink: true,
          align: "left",
          timer: false,
        },

        {
          detail: true,
          remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
